var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('zf-funnel-step',{attrs:{"title":"Art des Geräts","explanation":"Wähle bitte aus welche Art von Gerät du verbinden möchtest","remoteData":_vm.deviceTypes}},[_c('zf-option-selection',{attrs:{"options":_vm.deviceTypeOptions},on:{"option-selected":function($event){return _vm.onDeviceTypeSelected($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }